<template>
  <div class="page page--appointment-not-needed">
    <div class="container">
      <div>
        <div class="page-subtitle">Our advice to you</div>
        <h1 class="ascenti">Follow our self-care tips</h1>
        <div class="page-copy">
          <p>Based on what you’ve told us, it sounds like you don’t need to see a physio for now and your symptoms should improve with self-management.</p>
          <p>Try our online guide to help you manage your symptoms at home:</p>
          <a href="https://www.ascenti.co.uk/article/injury-care-guide" class="button button--blue">Open Guide</a>
          <p>If your symptoms worsen or you would like to speak to somebody, you are still welcome to <a :href="bookingUrl">book an online appointment.</a></p>
        </div>
      </div>

      <div>
        <img src="../assets/img/self-help.jpg" srcset="../assets/img/self-help.jpg 1x, ../assets/img/self-help@2x.jpg 2x" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentNotNeeded",

  computed: {
    bookingUrl() {
      return process.env.VUE_APP_BOOKING_URL;
    }
  },

  mounted() {
    this.goToStartIfSurveyNotComplete();
    this.$gtm.trackView('Appointment not needed', '/complete');

    this.setCurrentStep(null);

    this.setSurveyComplete(true);

    this.setNeedsAppointment(false);

    this.clearAnswers();

    this.setBodyPart(null);

    this.scrollToTop();
  },
}
</script>

<style lang="scss">
  .page--appointment-not-needed {
    .container {
      color: $color-dove-gray;
      display: flex;
      flex-wrap: wrap;
      font-size: 20px;
      line-height: 25px;

      @include screen(md) {
        flex-wrap: nowrap;
      }

      > div {
        flex-basis: 100%;

        &:nth-child(1) {
          @include screen(md) {
            margin-right: 40px;    
          }
        }

        &:nth-child(2) {          
          @include screen(md) {
            margin-left: 40px;    
          }
        }
      }

      .page-subtitle {
        font-size: 16px;
        line-height: 37px;
      }

      h1 {
        margin-bottom: 43px;
      }

      .page-copy {
        text-align: center;
        margin-bottom: 40px;

        p {
          text-align: left;
          margin-bottom: 30px;
        }

        .button {
          margin-bottom: 30px;
        }
      }

      img {
        display: block;
        max-width: 100%;
        border-radius: 1rem;
        margin: 0 auto;
      }
    }
  }
</style>
